import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from 'react-google-recaptcha';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { authHeader } from "../../helpers/auth-header";
import { getContactID, getSetting, getSupplierID, getSupportDetails, handleBackground, handleSuccess, isObject, showCustomError } from "../../helpers/general";
import mapMobileJpg from '../../images/maps/map-mobile.jpg?version=v6.0.443';
import mapMobileWeb from '../../images/maps/map-mobile.webp?version=v6.0.443';
import mapTabletJpg from '../../images/maps/map-tablet.jpg?version=v6.0.443';
import mapTabletWeb from '../../images/maps/map-tablet.webp?version=v6.0.443';
import mapFullJpg from '../../images/maps/map.jpg?version=v6.0.443';
import mapFullWeb from '../../images/maps/map.webp?version=v6.0.443';
import Translation from "../controls/Translation";
import Footer from "../layout/Footer";
import NavMenu from "../layout/NavMenu";


const ContactUs = () => {
    const [supportDetails, setSupportDetails] = useState({ telephoneNo: '', email: '', address: '' });
    const [captchaToken, setCaptchaToken] = useState(null);
    const [messageDetails, setMessageDetails] = useState({
        tendererID: -1,
        contactID: -1,
        companyName: '',
        fullName: '',
        contactEmail: '',
        telephoneNo: '',
        message: ''
    });
    const [recaptchaSiteKey, setRecaptchaSiteKey] = useState('');
    const recaptchaRef = useRef(null); // Create a reference to ReCAPTCHA

    const handleCaptchaChange = (token) => {
        setCaptchaToken(token);
    };

    const preloadMessageDetails = () => {
        var supplierID = getSupplierID();
        var contactID = getContactID();

        if (supplierID > 0 && contactID > 0) {
            fetch(`./SupplierUsers/GetTendererContactInfo?userID=${contactID}&supplierID=${supplierID}`, {
                method: 'GET',
                headers: authHeader(false, true)
            })
                .then(response => response.json())
                .then(data => {
                    setMessageDetails({
                        tendererID: supplierID,
                        contactID: contactID,
                        companyName: data.name,
                        fullName: data.fullName,
                        contactEmail: data.email,
                        telephoneNo: data.telephone
                    })

                    console.log(data)
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }


    useEffect(() => {
        handleBackground();
        preloadMessageDetails();

        getSetting('REACTPCHA_SITE_KEY')
            .then(x => setRecaptchaSiteKey(x));

        getSupportDetails()
            .then(data => {
                setSupportDetails({ telephoneNo: data.telephoneNo, email: data.email, address: data.address });
            });
    }, []);


    const handleChange = e => {
        e.persist();

        setMessageDetails(value => ({
            ...value,
            [e.target.name]: e.target.value
        }));
    }


    const handleSubmit = async () => {
        if (!captchaToken) {
            showCustomError('The reCaptcha has not been completed.', 'reCaptcha Failed', 'error');
            return;
        }

        const response = await fetch(`./ReCaptcha/VerifyReCaptcha`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token: captchaToken, siteSecret: process.env.REACT_APP_SITE_SECRET }),
        });

        const data = await response.json();

        if (data.success) {
            fetch(`./Correspondence/SubmitSupportMessage`, {
                method: 'POST',
                headers: authHeader(false, true),
                body: JSON.stringify(messageDetails)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success === true) {
                        handleSuccess('Message Sent', data.message, 'success');

                        setMessageDetails({
                            tendererID: -1,
                            contactID: -1,
                            companyName: '',
                            fullName: '',
                            contactEmail: '',
                            telephoneNo: '',
                            message: ''
                        });

                        isObject(document.getElementById('fullName')) && (document.getElementById('fullName').value = '');
                        isObject(document.getElementById('companyName')) && (document.getElementById('companyName').value = '');
                        isObject(document.getElementById('contactEmail')) && (document.getElementById('contactEmail').value = '');
                        isObject(document.getElementById('telephoneNo')) && (document.getElementById('telephoneNo').value = '');
                        isObject(document.getElementById('message')) && (document.getElementById('message').value = '');

                        preloadMessageDetails();
                        recaptchaRef.current.reset();

                    } else {
                        showCustomError('There has been a problem submitting your message, please try again.', 'Problem sending message', 'error');
                        recaptchaRef.current.reset();
                    }
                })
                .catch(err => {
                    console.log(err);
                    showCustomError('There has been a problem submitting your message, please try again.', 'Problem sending message', 'error');
                    recaptchaRef.current.reset();
                });
        } else {
            showCustomError('The reCaptcha has failed - please try again.', 'reCaptcha Failed', 'error');
            recaptchaRef.current.reset();
        }

        setCaptchaToken(null); // Clear token from state
    };


    return (
        <>
            <NavMenu />
            <main className="main-content u-container" fluid="true">
                <Card className='padding-l-25 padding-r-20 card main-content__inner'>
                    <CardHeader className="card-header card-header--no-icon">
                        <span>
                            Contact us
                        </span>
                    </CardHeader>
                    <CardBody>
                        <div style={{ maxWidth: "auto !important" }}>
                            <div className="l-contact-page">
                                <div className="l-contact-page__forms u-component-spacing">
                                    <Card className="c-contact-cards c-card" style={{ alignSelf: "flex-start" }}>
                                        <CardHeader style={{alignSelf: "stretch"}} className="card-header card-header--no-icon">
                                            <span>
                                                Contact details
                                            </span>
                                        </CardHeader>
                                        <CardBody style={{padding: "0 4rem 1.25rem"}}>
                                            <div className="c-contact-card">
                                                <svg className="c-contact-card__icon c-contact-card__icon--mail" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                                    <g transform="matrix(1,0,0,1,1.95613e-05,-9.64293e-08)">
                                                        <path d="M63.94,39.721L59.984,17.333C59.615,15.241 57.614,13.838 55.52,14.208L23.794,19.814C21.823,20.162 20.486,21.962 20.644,23.916C20.622,24.078 24.627,46.667 24.627,46.667C24.805,47.681 25.368,48.564 26.213,49.155C26.868,49.613 27.631,49.851 28.414,49.851C28.64,49.851 28.866,49.831 29.092,49.791L60.815,44.186C61.829,44.007 62.712,43.445 63.303,42.6C63.893,41.757 64.119,40.735 63.94,39.721ZM61.268,36.085L50.601,27.879C53.603,24.646 56.738,21.094 58.303,19.307L61.268,36.085ZM24.143,21.783L55.867,16.177C55.977,16.159 56.084,16.149 56.19,16.149C56.804,16.149 57.364,16.46 57.706,16.949C56.774,18.021 48.331,27.705 44.273,31.508C43.21,32.501 41.67,32.751 40.355,32.14C35.564,29.927 25.135,24.694 22.628,23.433C22.658,23.118 22.761,22.813 22.947,22.546C23.231,22.14 23.656,21.869 24.143,21.783ZM22.978,25.847C25.328,27.025 29.594,29.157 33.491,31.065L25.968,42.767L22.978,25.847ZM61.664,41.453C61.38,41.86 60.956,42.13 60.469,42.216L28.744,47.823C28.257,47.907 27.764,47.799 27.358,47.515C26.953,47.232 26.682,46.807 26.596,46.32L26.481,45.668L35.301,31.948C36.903,32.725 38.37,33.427 39.516,33.956C40.266,34.303 41.063,34.472 41.851,34.472C43.23,34.472 44.586,33.955 45.64,32.967C46.645,32.026 47.895,30.752 49.226,29.345L61.784,39.005L61.972,40.069C62.058,40.556 61.948,41.048 61.664,41.453Z" style={{ fill: "var(--text-color)", fillRule: "nonzero" }} ></path>
                                                    </g>
                                                    <path className="c-contact-card__icon-stroke" d="M19.008,29.867C18.912,29.324 18.392,28.956 17.85,29.057L0.826,32.065C0.282,32.16 -0.081,32.679 0.016,33.223C0.101,33.708 0.523,34.049 0.999,34.049C1.057,34.049 1.115,34.044 1.174,34.034L18.197,31.026C18.741,30.93 19.105,30.411 19.008,29.867Z" style={{ fill: "rgb(52,203,0)", fillRule: "nonzero" }} ></path>
                                                    <path className="c-contact-card__icon-stroke" d="M20.029,35.652C19.934,35.108 19.414,34.742 18.871,34.841L8.657,36.646C8.113,36.742 7.75,37.26 7.847,37.804C7.932,38.289 8.354,38.63 8.83,38.63C8.888,38.63 8.946,38.625 9.005,38.615L19.219,36.81C19.763,36.714 20.126,36.196 20.029,35.652Z" style={{ fill: "rgb(52,203,0)", fillRule: "nonzero" }} ></path>
                                                    <path className="c-contact-card__icon-stroke" d="M19.888,40.597L13.079,41.8C12.535,41.896 12.172,42.414 12.269,42.958C12.354,43.444 12.775,43.784 13.252,43.784C13.31,43.784 13.368,43.78 13.427,43.769L20.235,42.566C20.779,42.47 21.143,41.951 21.046,41.408C20.951,40.864 20.429,40.495 19.888,40.597Z" style={{ fill: "rgb(52,203,0)", fillRule: "nonzero" }} ></path>
                                                </svg>
                                                <span className="u-no-wrap">
                                                    <a href={`mailto:${supportDetails.email}`} className="c-cta c-cta__a"> {supportDetails.email}</a>
                                                </span>
                                            </div>
                                            <div className="c-contact-card">
                                                    <svg className="c-contact-card__icon c-contact-card__icon--phone" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill="var(--text-color)" d="M44.14 63.88a7.24 7.24 0 0 1-1.43-.14c-.67-.11-16.56-2.96-28.5-14.9C4.58 39.2 1.33 26.84.37 21.9a7.2 7.2 0 0 1 1.79-7.16l4.06-4.06a1.27 1.27 0 0 1 1.79 0l13.14 13.14c.5.5.5 1.3 0 1.79l-4.06 4.06-.31.3a5.38 5.38 0 0 0-.86 6.86 33.43 33.43 0 0 0 4.56 5.73 34.6 34.6 0 0 0 6.97 5.32 5.56 5.56 0 0 0 6.78-.99l.04-.04 4.06-4.06c.5-.5 1.3-.5 1.8 0l13.13 13.14c.5.5.5 1.3 0 1.8l-4.06 4.05a7.15 7.15 0 0 1-5.06 2.1Zm-1.06-2.65.1.02a4.63 4.63 0 0 0 4.23-1.26l3.17-3.16-11.35-11.35-3.2 3.2a8.09 8.09 0 0 1-9.86 1.4 37.12 37.12 0 0 1-7.48-5.72 35.94 35.94 0 0 1-4.9-6.18 7.94 7.94 0 0 1 1.51-10.3l3.16-3.17L7.11 13.36l-3.16 3.17a4.6 4.6 0 0 0-1.1 4.82c.9 4.67 3.97 16.51 13.15 25.7 11.02 11.01 26 13.98 27.08 14.18Z"/>
                                                        <path className="c-contact-card__icon-stroke" fill="#34cb00" fill-rule="nonzero" d="M46.85 35.15c-.7 0-1.27-.57-1.27-1.27 0-8.73-7.1-15.84-15.84-15.84a1.27 1.27 0 0 1 0-2.53 18.4 18.4 0 0 1 18.38 18.37c0 .7-.57 1.27-1.27 1.27Z"/>
                                                        <path className="c-contact-card__icon-stroke" fill="#34cb00" fill-rule="nonzero" d="M54.7 35.15c-.7 0-1.27-.57-1.27-1.27a23.71 23.71 0 0 0-23.7-23.68 1.27 1.27 0 0 1 0-2.54 26.25 26.25 0 0 1 26.23 26.22c0 .7-.57 1.27-1.27 1.27Z"/>
                                                        <path className="c-contact-card__icon-stroke" fill="#34cb00" fill-rule="nonzero" d="M62.56 35.15c-.7 0-1.27-.57-1.27-1.27A31.38 31.38 0 0 0 29.94 2.53a1.27 1.27 0 0 1 0-2.53 33.92 33.92 0 0 1 33.88 33.88c0 .7-.56 1.27-1.26 1.27Z"/>
                                                    </svg>
                                                <span className="u-no-wrap">
                                                    <a href={`tel:${supportDetails.telephoneNo}`} className="c-cta c-cta__a"> {supportDetails.telephoneNo}</a>
                                                </span>
                                            </div>
                                        </CardBody>
                                    </Card>
                                    <Card className="c-contact-form c-card">
                                        <CardHeader style={{alignSelf: "stretch"}} className="card-header card-header--no-icon">
                                            <span>
                                                Send us a message
                                            </span>
                                        </CardHeader>
                                        <CardBody style={{padding: "0 4rem 1.25rem"}}>
                                            <div className="c-form">
                                                <div className='c-form__input-group'>
                                                    <Translation ID="FullName" required htmlFor='fullName' />
                                                    <input name='fullName' id='fullName' type='text' className='c-form__input' required defaultValue={messageDetails.fullName} onChange={(e) => handleChange(e)} />
                                                </div>
                                                <div className='c-form__input-group'>
                                                    <Translation ID="CompanyName" required htmlFor='companyName' />
                                                    <input name='companyName' id='companyName' type='text' className='c-form__input' required defaultValue={messageDetails.companyName} onChange={(e) => handleChange(e)} />
                                                </div>
                                                <div className='c-form__input-group'>
                                                    <Translation ID="EmailAddress" required htmlFor='contactEmail' />
                                                    <input name='contactEmail' id='contactEmail' type='text' className='c-form__input' required defaultValue={messageDetails.contactEmail} onChange={(e) => handleChange(e)} />
                                                </div>
                                                <div className='c-form__input-group'>
                                                    <Translation ID="TelephoneNo" htmlFor='telephoneNo' />
                                                    <input name='telephoneNo' id='telephoneNo' type='text' className='c-form__input' required defaultValue={messageDetails.telephoneNo} onChange={(e) => handleChange(e)} />
                                                </div>
                                                <div className='c-form__input-group c-form__contactus__input-group--textarea'>
                                                    <Translation ID="Message" required htmlFor='message' />
                                                    <textarea name='message' id='message' type='textarea' className='c-form__input' rows="10" required onChange={(e) => handleChange(e)} />
                                                </div>

                                                {recaptchaSiteKey &&
                                                    <div className="c-form__recaptcha">
                                                        <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaSiteKey} onChange={handleCaptchaChange} />
                                                    </div>
                                                }

                                                <div>
                                                    <button className="c-cta" onClick={handleSubmit}>
                                                        Send message
                                                    </button>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                                <Card className="c-card l-contact-page__map u-component-spacing" style={{ alignSelf: "flex-start" }}>
                                    <CardHeader style={{alignSelf: "stretch"}} className="card-header card-header--no-icon">
                                        <span>
                                            Where to find us
                                        </span>
                                    </CardHeader>
                                    <CardBody>
                                        <div className="c-caption-over-image js-animate-in-view animation animation--scroll js-in-view">
                                            <picture className="c-caption-over-image__picture">
                                                <source srcSet={mapMobileWeb} type="image/webp" media="(min-width:1440px)" />
                                                <source srcSet={mapMobileJpg} type="image/jpeg" media="(min-width:1440px)" />
                                                <source srcSet={mapFullWeb} type="image/webp" media="(min-width:1280px)" />
                                                <source srcSet={mapFullJpg} type="image/jpeg" media="(min-width:1280px)" />
                                                <source srcSet={mapTabletWeb} type="image/webp" media="(min-width:960px)" />
                                                <source srcSet={mapTabletJpg} type="image/jpeg" media="(min-width:960px)" />
                                                <source srcSet={mapMobileWeb} type="image/webp" />
                                                <img src={mapMobileJpg} alt="Map indicating the location of the In-tend office" loading="lazy" width="1258" height="484" className="c-caption-over-image__image" />
                                            </picture>
                                            <section className="c-caption-over-image__caption">
                                                <address className="vcard u-text-left u-component-spacing">
                                                    <span className="adr c-address">
                                                        <span className="street-address">
                                                            <span className="c-address__address-line">In-tend House</span>
                                                            <span className="c-address__address-line">74 High Street</span>
                                                        </span>
                                                        <span className="locality c-address__address-line">Maltby, Rotherham</span>
                                                        <span className="region c-address__address-line">South Yorkshire</span>
                                                        <span className="c-address__address-line">
                                                            <span className="postal-code">S66 7BN,
                                                                <span className="country-name"> United Kingdom</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </address>
                                                <a href="https://g.page/intendltd?share" className="c-cta u-component-spacing" target="_blank" rel="noreferrer">Open in Google Maps</a>
                                            </section>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </main>

            <Footer />
        </>
    )
}

export default ContactUs;